import { TranslateService } from '@ngx-translate/core';
import { compareAsc } from 'date-fns';

import { epicDependencies } from '../../../store';
import { PayloadAction } from '../../../store.model';
import { ActionType } from '../transcript-import-dialog.action';
import { TranslationKeyMap } from '../transcript-import-dialog.i18n';
import { TranscriptImportDialogState } from '../transcript-import-dialog.state';

import { ReceiveMeetings } from './receive-meetings.action';

export function receiveMeetingsReducer(
    state: TranscriptImportDialogState,
    action: PayloadAction<ActionType, ReceiveMeetings>,
): TranscriptImportDialogState {
    if (
        action.payload.meetings == null ||
        action.payload.meetings.length === 0
    ) {
        return state;
    }

    // TODO FIXME. this can be done better
    const tlService =
        epicDependencies.injector.get<TranslateService>(TranslateService);
    const unknownUser: string = tlService.instant(
        TranslationKeyMap._11262_UNKNOWN_USER,
    );

    const nextMeetings = [...(state.meetings ?? [])];
    action.payload.meetings?.forEach((meeting) => {
        if (meeting.transcript == null) {
            return;
        }

        meeting.startDate =
            meeting.startDate == null ? null : new Date(meeting.startDate);
        meeting.endDate =
            meeting.endDate == null ? null : new Date(meeting.endDate);
        meeting.createdOn =
            meeting.createdOn == null ? null : new Date(meeting.createdOn);

        const participantStrs: string[] = [];
        let unknownUserNum = 1;

        meeting.participants?.forEach((e) => {
            // exclude self
            if (e.userId === state.userId) {
                return;
            }

            if (e.userId == null || e.userName == null) {
                participantStrs.push(`${unknownUser} (${unknownUserNum++})`);
            } else {
                participantStrs.push(e.userName);
            }
        });

        participantStrs?.sort((a, b) => a.localeCompare(b));

        // TODO fixme. only checks first transcript
        const hasUnImportedTranscript =
            meeting.transcript?.transcriptId == null;

        nextMeetings.push({
            ...meeting,
            participantsStr: participantStrs.join(', '),
            hasUnImportedTranscript,
        });
    });

    nextMeetings.sort((a, b) => compareAsc(a.startDate, b.startDate));

    return {
        ...state,
        meetings: nextMeetings,
    };
}
